import { createContext } from "react";
import { BagManager } from "../Models/Bag";
 
export const BagManagerContext = createContext<BagManager | null>(null) 